import React, {useState, useEffect, useContext, useCallback} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import FullBodyContentView from '../../views/fullBodyContentView';
import RunVerification from './run-verification';

function SMVComplete({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<RunVerification />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;
    onLeft();
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands({onLeft});
  }, [onLeft]);

  return (
    <FullBodyContentView
      title="SMV Complete"
      fullCaption="Result...................................................
      ...Pass................................................
      .........................................................
      .........................................................
      .........................................................
      .........................................................

      "
    />
  );
}

export default SMVComplete;
